import styled from "styled-components";
import { Text } from "components/Text";

export const Description = styled(Text.Body1)`
  color: ${({ theme }) => theme.color.additional.dark.value};
`;
